import React, { Component } from 'react';
import request from 'superagent';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import './tab.css'
import { Button, Input, Icon } from 'antd';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import NotificationManager from '../../commons/CustomNotificationManager.js';
import Loading from '../../commons/Loading.js';
import { Permissions } from '../../commons/Constants';
import { permissionCtrlHOC } from "../../commons/CommonUtils";
import SvgIcon from '../../commons/SvgIcon';
import TenantAddUser from "./TenantAddUser";
import TenantFeatureControl from "./TenantFeatureControl";

class TenantDetailView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            assetList: [],
            tenantDetail: {},
            tid: "",
            editMode: false,
            companyName: ''
        };
    }

    componentDidMount() {
        const id = this.props.tenantId;
        this.setState({tid: id});
        this.loadAllData(id);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.tenantId && this.state.tid !== nextProps.tenantId) {
            const id = nextProps.tenantId;
            this.setState({
                tid: id,
                loading: true,
                assetList: [],
                editMode: false,
                tenantDetail: {}
            });
            this.loadAllData(id);
        }
    }

    loadAllData = (id) => {
        this.getTenantById(id)
            .then(() => {
                return this.getAssetsByTenantId(id);
            })
            .then(() => {
                this.setState({loading: false});
            })
            .catch(err => {
                console.error("Get tenant detail failed.", err);
                this.setState({
                    loading: false,
                    assetList: [],
                    editMode: false,
                    tenantDetail: {}
                });
            });
    }

    getAssetsByTenantId = (id) => {
        return request.get('/api/tenant-manager/' + id + '/assets').withCredentials()
            .then((response) => {
                const list = response.body.tenantAssetsList;
                let assets = [];
                for (let i = 0; i < list.length; i++) {
                    let deviceList = list[i];
                    let assetType = deviceList.assetType;
                    for (let j = 0; j < deviceList.assetList.length; j++) {
                        const asset = {
                            serialNumber: deviceList.assetList[j].serialNumber,
                            assetType: assetType
                        };
                        assets.push(asset);
                    }
                }
                this.setState({assetList: assets});
            });
    }

    getTenantById = (id) => {
        console.log("get tenant by id: " + id);
        return request.get('/api/tenant-manager/' + id)
            .then((response) => {
                const detail = response.body;
                this.setState({tenantDetail: detail, companyName: detail.companyName, editMode: false});
                return detail;
            });
    }


    createCustomToolBar = props => {
        return (
            <div>
                <div className='searchFiled'>
                    { props.components.searchPanel }
                </div>
            </div>
        );
    }

    languageFormat = (language) => {
        const value = this.props.langOptions.filter(function(item) { return item.value === language });
        if (value.length > 0) {
            return value[0].label;
        } else {
            return language;
        }
    }

    editCompanyName = () => {
        const { companyName, tid, tenantDetail } = this.state;
        if (companyName === '') {
            return;
        }
        request.put('/api/tenant-manager/' + tid).withCredentials().send({companyName})
            .end((error, response) => {
                if (error) {
                    console.error(error);
                    NotificationManager.error('Failed to edit company name.');
                } else {
                    NotificationManager.success('Succeed to edit company name.');
                    this.setState({editMode: false});
                    tenantDetail['companyName'] = companyName;
                    this.props.freshList(tenantDetail);
                }
            });
    }

    cancelEdit = () => {
        this.setState({editMode: false, companyName: this.state.tenantDetail.companyName});
    }

    render() {
        const { tid, assetList, loading, tenantDetail, editMode, companyName } = this.state;

        const assetOptions = {
            defaultSortName: 'assetType',
            defaultSortOrder: 'asc',
            toolBar: this.createCustomToolBar,
            noDataText: loading ? <Loading /> : 'No assets found.',
            searchDelayTime: 500
        }

        return (
            <div className="page-tenant-detail">
                <div>
                    <div className="panel-body">
                        <div className="form-group">
                            <b className="tenant-name">
                                {editMode ? (
                                    <div>
                                        <Input defaultValue={companyName} autoFocus
                                               style={{width: 300, height: 35, fontSize: 20}}
                                               onChange={e => {this.setState({companyName: e.target.value})}}/>
                                        <Icon type="check-circle" title="Save" onClick={this.editCompanyName}/>
                                        <Icon type="close-circle" title="Cancel" onClick={this.cancelEdit}/>
                                    </div>
                                ) : (
                                    <div>
                                        {companyName}
                                        <Icon type="edit" title="Edit Company Name"
                                              onClick={() => {this.setState({editMode: true})}}/>
                                    </div>
                                )}
                            </b>
                            {!loading && companyName === '' && <span style={{marginLeft: 13}}>Company Name is required.</span>}
                        </div>

                        <div className="form-group">
                            <label className="col-sm-3 control-label">ID:</label>
                            <div className="col-sm-9">
                                <label className="control-label">{tenantDetail.tenantId}&nbsp;</label>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="col-sm-3 control-label">Domain:</label>
                            <div className="col-sm-9">
                                <label className="control-label">{tenantDetail.tenantDomain}&nbsp;</label>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="col-sm-3 control-label">Email:</label>
                            <div className="col-sm-9">
                                <label className="control-label">{tenantDetail.adminEmail}&nbsp;</label>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="col-sm-3 control-label">Language:</label>
                            <div className="col-sm-9">
                                <label className="control-label">{this.languageFormat(tenantDetail.language)}&nbsp;</label>
                            </div>
                        </div>
                    </div>
                    <Tabs>
                        <TabList>
                            <Tab>{assetList.length} Assets</Tab>
                            {permissionCtrlHOC([Permissions.TenantManager.ADD])(<Tab>Add User</Tab>)}
                            <Tab>Feature Control</Tab>
                        </TabList>

                        <TabPanel>
                            <BootstrapTable data={ assetList } search={ true } multiColumnSearch={ true }
                                            options={ assetOptions } striped hover condensed>
                                <TableHeaderColumn dataField='assetType' dataSort>Type</TableHeaderColumn>
                                <TableHeaderColumn dataField='serialNumber' isKey dataSort>Serial Number</TableHeaderColumn>
                            </BootstrapTable>
                        </TabPanel>

                        {permissionCtrlHOC([Permissions.TenantManager.ADD])(
                            <TabPanel>
                                <TenantAddUser tenantId={tid} domain={tenantDetail['tenantDomain']}/>
                            </TabPanel>
                        )}

                        <TabPanel>
                            <TenantFeatureControl tenantId={tid}/>
                        </TabPanel>
                    </Tabs>

                    <div className="page-close" onClick={this.props.close}>
                        <span className="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
                    </div>
                </div>
            </div>
        );
    }
}

export default TenantDetailView;


// WEBPACK FOOTER //
// ./src/modules/tenants/TenantDetailView.js